import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionStatesComponent } from './transaction-states.component';
import { RouterModule, Routes } from '@angular/router';
import { TransactionStatesCardModule } from './transaction-states-card/transaction-states-card.module';
import { CoreModule } from '@app/core/core.module';
import { TranslateModule } from '@ngx-translate/core';
import { RowTransactionListModule } from '@app/dashboard/transactions/transaction-list/row-transaction-list/row-transaction-list.module';
import { AlertModule } from '@app/core/components/alert-component/alert.module';
import { ReactiveFormsModule } from '@angular/forms';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyFormFieldModule as MatFormFieldModule } from '@angular/material/legacy-form-field';
import { MatLegacyInputModule as MatInputModule } from '@angular/material/legacy-input';
import { SubmitModule } from '@app/core/components/submit/submit.module';
import { HelperModule } from '../../../../ui/shared/components/helper/helper.module';

const routes: Routes = [
    {
        path: '',
        component: TransactionStatesComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class TransactionStatesRoutingModule {}

@NgModule({
    declarations: [TransactionStatesComponent],
    imports: [
        CommonModule,
        TransactionStatesRoutingModule,
        TransactionStatesCardModule,
        RowTransactionListModule,
        CoreModule,
        TranslateModule,
        AlertModule,
        ReactiveFormsModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule,
        HelperModule,
        SubmitModule
    ]
})
export class TransactionStatesModule {}
